import React, { Fragment, useRef, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Partners from "./Partners";
import TemplateCta from "../template/TemplateCta";
import PhotoCta from "../photo/PhotoCta";
import usePhotoOffer from "../photo/usePhotoOffer";
import AdCta from "../ads/AdCta";
import HomeBundles from "../bundle/HomeBundles";
import { uploadAnonFile } from "../../actions/file";
import { toastr } from "react-redux-toastr";
import useFileDrop from "../../utils/useFileDrop";

const Landing = ({ isAuthenticated, uploadAnonFile }) => {
  const [formData, setFormData] = useState({
    filetouploadVM: null,
    setConfig: false,
    pages: "all",
    copies: 1,
    side: false,
    color_type: "mono",
    layout: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [qrCodeData, setQrCodeData] = useState(null);
  const [isModalActive, setIsModalActive] = useState(false);
  const canvasRef = useRef(null);
  const photos = usePhotoOffer();

  const { filetouploadVM } = formData;

  const pickFile = (file) => {
    if (file && !file.name.toLowerCase().endsWith(".pdf")) {
      toastr.warning("Энэ хэсэгт зөвхөн PDF файл илгээх боломжтой.");
      setFormData({ ...formData, filetouploadVM: null });
      return;
    }

    setFormData({ ...formData, filetouploadVM: file });
  };

  const onChangeFile = (event) => {
    pickFile(event.target.files[0] || null);
    event.target.value = "";
  };

  const dragging = useFileDrop(pickFile, isLoading || isModalActive);

  const resetField = () => {
    setFormData({
      filetouploadVM: null,
      setConfig: false,
      pages: "all",
      copies: 1,
      side: false,
      color_type: "mono",
      layout: false,
    });
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    if (!filetouploadVM) {
      toastr.warning("Файлаа сонгоно уу!");
      return;
    }

    setIsLoading(true);
    setIsModalActive(true);
    try {
      const response = await uploadAnonFile(formData);
      if (response && response.qr) {
        setQrCodeData(response.qr);
      }
      resetField();
    } catch (error) {
      setIsModalActive(false);
      toastr.error("Файл хуулахад алдаа гарлаа.");
    } finally {
      setIsLoading(false);
    }
  };

  const downloadQRCode = () => {
    const canvas = canvasRef.current;
    const img = new Image();
    img.src = qrCodeData;
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "CloudPrint-QRCode.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };
  };

  const closeModal = () => {
    setIsModalActive(false);
    setQrCodeData(null);
  };

  if (isAuthenticated) {
    return <Redirect to="/upload" />;
  }

  return (
    <Fragment>
      <main className="home-page">
        <section className="home-hero">
          <div className="container home-hero-inner">
            <div className="columns is-vcentered is-variable is-8">
              <div className="column is-6 home-hero-copy">
                <span className="home-eyebrow">
                  <span className="home-eyebrow-dot" aria-hidden="true"></span>
                  Өөртөө үйлчлэх хэвлэлийн киоск
                </span>
                <h1 className="home-title">
                  Файл, зургаа
                  <span> киоскоос хэвлээрэй.</span>
                </h1>
                <p className="home-lead">
                  Флаш диск, кабель хэрэггүй. PDF файл, зургаа утаснаасаа
                  илгээгээд үүссэн QR кодоо Cloud Print төхөөрөмж дээр уншуулна.
                </p>

                {/* What there is to print; photos only while they are on sale */}
                <div className="home-services">
                  <label htmlFor="home-file" className="home-service">
                    <span className="home-service-icon is-pdf" aria-hidden="true">
                      <i className="fas fa-file-pdf"></i>
                    </span>
                    <span>
                      <b>PDF файл</b>
                      <small>Утас, компьютерээс</small>
                    </span>
                  </label>
                  <Link to="/templates" className="home-service">
                    <span className="home-service-icon is-template" aria-hidden="true">
                      <i className="fas fa-file-signature"></i>
                    </span>
                    <span>
                      <b>Бэлэн загвар</b>
                      <small>Өргөдөл, CV</small>
                    </span>
                  </Link>
                  {photos && photos.price && (
                    <Link to="/photo" className="home-service">
                      <span className="home-service-icon is-photo" aria-hidden="true">
                        <i className="fas fa-image"></i>
                      </span>
                      <span>
                        <b>10×15 зураг</b>
                        <small>Фото цаасан дээр</small>
                      </span>
                    </Link>
                  )}
                  {photos && photos.idPrice && (
                    <Link to="/idphoto" className="home-service">
                      <span className="home-service-icon is-id" aria-hidden="true">
                        <i className="fas fa-id-badge"></i>
                      </span>
                      <span>
                        <b>Цээж зураг</b>
                        <small>Паспорт, виз, үнэмлэх</small>
                      </span>
                    </Link>
                  )}
                </div>

                <ul className="home-trust-row">
                  <li><i className="fas fa-user-check" aria-hidden="true"></i> Бүртгэл шаардлагагүй</li>
                  <li><i className="fas fa-clock" aria-hidden="true"></i> QR 24 цаг хүчинтэй</li>
                  <li><i className="fas fa-palette" aria-hidden="true"></i> Хар цагаан, өнгөт</li>
                </ul>
              </div>

              <div className="column is-6">
                <div className="home-upload-shell">
                  <div className="home-upload-glow" aria-hidden="true"></div>
                  <form className="home-upload-card" onSubmit={handleUpload}>
                    <div className="home-card-heading">
                      <div>
                        <span className="home-card-kicker">ЭХЛЭХЭД БЭЛЭН</span>
                        <h2>Файлаа илгээнэ үү</h2>
                      </div>
                      <span className="home-secure-badge">
                        <i className="fas fa-lock"></i> Secure
                      </span>
                    </div>

                    <label
                      className={`home-dropzone ${filetouploadVM ? "has-file" : ""} ${
                        dragging ? "is-dragging" : ""
                      }`}
                    >
                      <input
                        id="home-file"
                        type="file"
                        name="filetouploadVM"
                        onChange={onChangeFile}
                        accept=".pdf,application/pdf"
                      />
                      <span className="home-upload-icon">
                        <i
                          className={
                            dragging
                              ? "fas fa-file-download"
                              : filetouploadVM
                              ? "fas fa-check"
                              : "fas fa-cloud-upload-alt"
                          }
                        ></i>
                      </span>
                      <strong>
                        {dragging
                          ? "Файлаа тавина уу"
                          : filetouploadVM
                          ? filetouploadVM.name
                          : "Файлаа энд сонгоно уу"}
                      </strong>
                      <span className="home-dropzone-copy">
                        {filetouploadVM && !dragging
                          ? "Файл бэлэн боллоо"
                          : "Файлаа чирж оруулах эсвэл төхөөрөмжөөсөө сонгоно уу"}
                      </span>
                      <span className="home-choose-button">
                        {filetouploadVM ? "Файл солих" : "Файл сонгох"}
                      </span>
                      <small>Одоогоор зөвхөн PDF файл дэмжинэ</small>
                    </label>

                    <button
                      type="submit"
                      className="home-submit-button"
                      disabled={isLoading}
                    >
                      <span>{isLoading ? "Илгээж байна..." : "Файл илгээж QR авах"}</span>
                      <i className="fas fa-arrow-right"></i>
                    </button>
                    <p className="home-privacy-note">
                      <i className="fas fa-info-circle"></i>
                      Таны файл зөвхөн хэвлэхэд ашиглагдаж, хугацаа дуусмагц устгагдана.
                    </p>
                  </form>

                </div>
              </div>
            </div>
          </div>
        </section>

        <Partners />

        <section className="home-template-section">
          <div className="container">
            <TemplateCta />
            <PhotoCta />
            <AdCta />
          </div>
        </section>

        <HomeBundles />

        <section className="home-how section">
          <div className="container">
            <div className="home-section-heading has-text-centered">
              <span>ХЭРХЭН АЖИЛЛАДАГ ВЭ?</span>
              <h2>Гуравхан алхмаар хэвлэнэ</h2>
              <p>Бүртгүүлэх шаардлагагүй. Нэг минут хүрэхгүй хугацаанд бэлэн.</p>
            </div>

            <div className="columns is-variable is-6 home-step-grid">
              <div className="column">
                <div className="home-step-card">
                  <span className="home-step-number">01</span>
                  <div className="home-step-icon"><i className="fas fa-file-upload"></i></div>
                  <h3>Файлаа оруулах</h3>
                  <p>Хэвлэх файлаа утас эсвэл компьютерээсээ сонгоно.</p>
                </div>
              </div>
              <div className="column">
                <div className="home-step-card">
                  <span className="home-step-number">02</span>
                  <div className="home-step-icon"><i className="fas fa-qrcode"></i></div>
                  <h3>QR код авах</h3>
                  <p>Таны файлд зориулсан нэг удаагийн QR код үүснэ.</p>
                </div>
              </div>
              <div className="column">
                <div className="home-step-card">
                  <span className="home-step-number">03</span>
                  <div className="home-step-icon"><i className="fas fa-print"></i></div>
                  <h3>Киоскоос хэвлэх</h3>
                  <p>QR кодоо уншуулаад тохиргоогоо сонгон шууд хэвлэнэ.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="home-feature section">
          <div className="container">
            <div className="columns is-vcentered is-variable is-8">
              <div className="column is-6 home-feature-visual">
                <div className="home-printer-halo"></div>
                <img src="assets/img/illustrations/printer.webp" width="940" height="940" loading="lazy" alt="Cloud Print хэвлэх төхөөрөмж" />
                <div className="home-floating-card home-floating-card-top">
                  <i className="fas fa-check-circle"></i>
                  <span><b>Файл бэлэн</b><small>QR амжилттай үүслээ</small></span>
                </div>
                <div className="home-floating-card home-floating-card-bottom">
                  <i className="fas fa-map-marker-alt"></i>
                  <span><b>Ойрын киоск</b><small>Танд үргэлж ойрхон</small></span>
                </div>
              </div>
              <div className="column is-5 is-offset-1 home-feature-copy">
                <span className="home-feature-kicker">CLOUD PRINT</span>
                <h2>Хэвлэх ажлыг илүү энгийн болгоно</h2>
                <p>
                  Монголд бүтээгдсэн, cloud технологид суурилсан өөртөө үйлчлэх
                  хэвлэлийн систем. Сургууль, оффис, үйлчилгээний төвд хаанаас ч
                  найдвартай хэвлээрэй.
                </p>
                <ul>
                  <li><i className="fas fa-check"></i> Тусгай програм суулгахгүй</li>
                  <li><i className="fas fa-check"></i> Гар утас, компьютерээс ашиглана</li>
                  <li><i className="fas fa-check"></i> Хар цагаан болон өнгөт хэвлэлт</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="home-footer">
        <div className="container">
          <div className="home-footer-main">
            <div className="home-footer-brand">
              <img src="assets/img/cloudprint-logo.png" width="164" height="100" loading="lazy" alt="Cloud Print" className="home-footer-logo" />
              <p>Хэвлэх ажлыг хүн бүрт ойртуулна.</p>
              <div className="home-socials">
                <a href="https://www.facebook.com/Cloudprint.mn" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                <a href="https://www.instagram.com/cloudprint.mn/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              </div>
            </div>
            <div>
              <h3>Байршил</h3>
              <p>УБ, ЧД, 1-р хороо, Express Tower,<br />3 давхар, 303 тоот</p>
            </div>
            <div>
              <h3>Холбоо барих</h3>
              <p>8898 7266<br />8884 4114<br />nirgesystems@gmail.com</p>
            </div>
          </div>
          <div className="home-footer-bottom">
            <span>© {new Date().getFullYear()} Nirge Systems</span>
            <span>Now you see your future</span>
          </div>
        </div>
      </footer>

      {isModalActive && (
        <div className="modal is-active home-qr-modal">
          <div className="modal-background" onClick={closeModal}></div>
          <div className="modal-content">
            <div className="box has-text-centered home-qr-box">
              {isLoading ? (
                <div className="home-modal-loading">
                  <img src="assets/img/loaders/uploadLoader.gif" alt="Файл илгээж байна" />
                  <h2>Файлыг илгээж байна...</h2>
                  <p>Түр хүлээнэ үү.</p>
                </div>
              ) : (
                <div>
                  <span className="home-modal-success"><i className="fas fa-check"></i></span>
                  <h2>Файл амжилттай хуулагдлаа</h2>
                  <p>Энэ QR кодыг Cloud Print киоск дээр уншуулаарай.</p>
                  <div className="home-qr-code">
                    <img src={qrCodeData} alt="Таны хэвлэх QR код" />
                    <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
                  </div>
                  <button onClick={downloadQRCode} className="home-download-button">
                    <i className="fas fa-download"></i> QR код татах
                  </button>
                  <p className="home-qr-expiry"><i className="fas fa-clock"></i> QR код 24 цагийн турш хүчинтэй.</p>
                </div>
              )}
            </div>
          </div>
          <button className="modal-close is-large" aria-label="Хаах" onClick={closeModal}></button>
        </div>
      )}
    </Fragment>
  );
};

Landing.propTypes = {
  isAuthenticated: PropTypes.bool,
  uploadAnonFile: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { uploadAnonFile })(Landing);
